import palette from '../palette';

const MuiSvgIcon = {
  variants: [
    // Added position as its own variation because buttonsChild and fileHeaderChild are using it
    {
      props: { position: 'right' },
      style: {
        marginLeft: '8px',
      },
    },
    {
      props: { position: 'left' },
      style: {
        marginRight: '8px',
      },
    },
    {
      props: { variant: 'buttonsChild' },
      style: {
        '.Mui-disabled  &': {
          color: palette.text.disabled,
        },
        color: palette.primary.main,
        fontSize: 20, // based on v4 whose `iconFontSize` prop was 20
        marginTop: -2, // Fix icon vertical alignment as we did in v4
      },
    },
    {
      props: { variant: 'buttonsDragHandle' },
      style: {
        '.Mui-disabled  &': {
          color: palette.text.disabled,
        },
        color: palette._next.table.tableHeader,
        fontSize: 20, // based on v4 whose `iconFontSize` prop was 20
        marginTop: -2, // Fix icon vertical alignment as we did in v4
      },
    },
    {
      props: { variant: 'buttonsDragButtons' },
      style: {
        '.Mui-disabled  &': {
          color: palette.text.disabled,
        },
        color: palette._next.action.active,
        fontSize: 20, // based on v4 whose `iconFontSize` prop was 20
        marginTop: -2, // Fix icon vertical alignment as we did in v4
      },
    },

    {
      props: { variant: 'fileHeaderChild' },
      style: {
        display: 'block',
        fontSize: 20,
      },
    },
  ],
};

export default MuiSvgIcon;
